var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('span',[_vm._v(_vm._s(_vm.type.currency)+" Wallet")])]),_c('v-card-text',[_c('h1',[_vm._v(_vm._s(_vm.wallet.available))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }